import { ActivatedRouteSnapshot, CanActivateFn, createUrlTreeFromSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router';
import { AuthGuardData, createAuthGuard } from 'keycloak-angular';

const isAccessAllowed = (
  route: ActivatedRouteSnapshot,
  _: RouterStateSnapshot,
  authData: AuthGuardData,
): Promise<boolean | UrlTree> => {
  const { authenticated } = authData;

  if (!authenticated) {
    return Promise.resolve(createUrlTreeFromSnapshot(route, ['/']));
  }

  return Promise.resolve(true);
};

export const onlyAuth = createAuthGuard<CanActivateFn>(isAccessAllowed);
